import React from 'react';
import styled from 'styled-components';
import {
  Layout,
  Map,
  ContactCard,
  ContactForm,
  Container,
} from '../components';

// Constants
import { media } from '../constants/theme';

// Data
import pageContext from '../data/pages/contact.json';

const StyledFlexBox = styled.div`
  @media ${media.notMobile} {
    display: flex;
  }

  > div:first-child {
    margin-bottom: 4rem;
    
    @media ${media.notMobile} {
      margin-right: 6rem;
      flex-shrink: 0;
    }
  }
`;

const Contact = ({ data }) => {
  const contact = data.site.siteMetadata;

  return (
    <Layout pageContext={pageContext}>
      <Container maxWidth="980px">
        <StyledFlexBox>
          <div>
            <ContactCard contact={contact} />
          </div>
          <div>
            <ContactForm contact={contact} />
          </div>
        </StyledFlexBox>
      </Container>
      <div style={{ height: '50vh' }}>
        <Map
          apiKey="AIzaSyBJxxs7Nrnf-TpBFKF8FxEbAr3pCGGnI4Y"
          center={{ lat: parseFloat(contact.latitude), lng: parseFloat(contact.longitude) }}
        />
      </div>
    </Layout>
  );
};

export default Contact;

export const query = graphql`
  query {
    site {
      siteMetadata {
        address
        city
        province
        postalCode
        phone
        mobile
        email
        latitude
        longitude
      }
    }
  }
`;
